import React, { useContext, useEffect } from "react";

// import components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Acheivements from "./components/Acheivements";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackTopBtn from "./components/BackTopBtn";
import Github from "./components/Github";
import Connection from "./components/Connection";
import CustomCursor from "./components/CustomCursor";
import Certificates from "./components/Certificates";
import PreLoader from "./components/PreLoader";
import { ThemeContext } from "@emotion/react";

function preventCopyPaste(event) {
  event.preventDefault();
}
const handleKeyDown = (event) => {
  if (event.ctrlKey && event.keyCode === 85) {
    event.preventDefault();
  }
};
function handleContextMenu(event) {
  event.preventDefault();
}


const App = () => {
  useEffect(() => {
    // document.addEventListener('keydown', handleKeyDown);
    // document.addEventListener('copy', preventCopyPaste);
    // document.addEventListener('paste', preventCopyPaste);
    // document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('copy', preventCopyPaste);
      document.removeEventListener('paste', preventCopyPaste);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return (
    <>
      <div className="bg-white relative">
        <CustomCursor />
        <Header />
        <Hero />
        <About />
        <Skills />
        <Acheivements />
        <Certificates />
        <Portfolio />
        <Github />
        {/* <Brands /> */}
        {/* <Services /> */}
        {/* <Testimonials /> */}
        <Contact />
        <Footer />
        <BackTopBtn />
        <Connection />
      </div>
    </>
  );
};

export default App;
